import { put, call } from "redux-saga/effects";
import {
  signUp,
  LoginService,
  authCheckService,
  updatePassword,
  logout,
} from "../service/signUp";
import {
  signUpSuccess,
  loginSucess,
  authCheckSucess,
  updatePasswordSucess,
  LogoutSucess,
} from "../action/signupaction";
import * as types from "../action.type";
export function* signUpSaga(data) {
  try {
    const response = yield call(signUp, data);

    yield put(signUpSuccess(response.data));
  } catch (error) {
    yield put({ type: types.SIGN_UP_ERROR, error });
  }
}
export function* loginSaga(data) {
  try {
    const response = yield call(LoginService, data);

    yield put(loginSucess(response.data));

    if (response.data.success) {
      window.location.replace("/app/dashboard");
    }
  } catch (error) {
    yield put({ type: types.LOGIN_ERROR, error });
  }
}

export function* authCheckSaga(data) {
  const response = yield call(authCheckService, data);
  if (response && !response.error) {
    yield put(authCheckSucess(response.data));
  } else {
    yield put({ type: types.AUTH_CHECK_ERROR, response });
  }
}
export function* updatePasswordSaga(data) {
  const response = yield call(updatePassword, data);
  if (response && !response.error) {
    yield put(updatePasswordSucess(response.data));
  } else {
    yield put({ type: types.UPDATE_PASSWORD_ERROR, response });
  }
}

export function* logoutService(data) {
  const response = yield call(logout, data);
  if (response && !response.error) {
    yield put(LogoutSucess(response.data));
  } else {
    yield put({ type: types.LOGOUT_ERROR, response });
  }
}
